import { TFunction } from 'i18next';

const MS_PER_DAY = 24 * 60 * 60 * 1000;
const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

/**
 * "Ajouté aujourd'hui" / "Ajouté il y a 5 j" / "Ajouté le 17 août".
 *
 * The pantry row already says how fresh an item is; this says when it arrived,
 * which is what tells two lots of the same food apart — the tofu from today's
 * delivery and the one that has been in the fridge since last week.
 */
export function addedLabel(
  t: TFunction,
  dateAdded: string | undefined,
  today: Date = new Date(),
  locale: string = 'fr-CA'
): string {
  if (!dateAdded) return '';

  const added = new Date(dateAdded);
  if (Number.isNaN(added.getTime())) return '';

  const days = Math.round(
    (startOfDay(today).getTime() - startOfDay(added).getTime()) / MS_PER_DAY
  );

  // Clocks disagree between devices; "added in 2 days" helps nobody.
  if (days <= 0) return t('pantry.added.today');
  if (days === 1) return t('pantry.added.yesterday');
  if (days <= 6) return t('pantry.added.days', { count: days });

  return t('pantry.added.on', {
    date: added.toLocaleDateString(locale, { month: 'long', day: 'numeric' }),
  });
}
